import styled from 'styled-components'

export const _FadeInOnMount = styled.div`
  width: 100%;
  .fade-top-appear {
    opacity: 0;
    transform: translateY(-5%);
    backface-visibility: hidden;
  }
  .fade-top-enter-done {
    opacity: 1;
    transform: translateY(0%);
    transition: opacity 0.5s 0.2s, transform 0.5s 0.2s;
    backface-visibility: hidden;
  }
  .fade-top-done-exit {
    opacity: 0;
    transition: opacity 0.5s;
    backface-visibility: hidden;
  }

  .fade-appear {
    opacity: 0;
    backface-visibility: hidden;
  }
  .fade-enter-done {
    opacity: 1;
    transition: opacity 0.5s 0s;
    backface-visibility: hidden;
    transform: translateZ(0);
  }
  .fade-left-appear {
    opacity: 1;
    transform: translateX(-100%);
    backface-visibility: hidden;
  }
  .fade-left-enter-done {
    opacity: 1;
    transform: translateX(0);
    transition: opacity 0.5s 0.2s, transform 120ms 50ms ease-in;
    backface-visibility: hidden;
  }
  
  .fade-in-bottom-enter {
    opacity: 0;
    transform: translateY(100%);
    transition: all 0ms;
  }
  .fade-in-bottom-enter-appear {
    opacity: 0;
    transform: translateY(100%);
    backface-visibility: hidden;

  }
  .fade-in-bottom-enter-done {
    opacity: 1;
    transform: translateY(0%);
    backface-visibility: hidden;
    transition: opacity 250ms, transform 250ms ease-out;
  }
`
